import { Component, Vue, Prop } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import MessageError from '@/components/edit/MessageError/index.vue'
import IndicatorOpenPortal from '@/components/edit/IndicatorOpenPortal/index.vue'
import searchHelper from '@/helpers/search'
import tableHelper from '@/helpers/table'
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

@Component({
	components: {
		Loader,
		MessageError,
	},
})
export default class SelectPortal extends Vue {
	@Prop({ required: true }) readonly options
	@Prop() readonly model
	@Prop() readonly status

	localModel = null
	mounted() {
		this.localModel = this.model
	}

	onInput() {
		this.$emit('input', this.localModel)
	}
}
